import React, {useMemo, useCallback, useState, useContext } from 'react';
import { SectionTitle } from '../../../components/Dashboard/SectionTitle/SectionTitle';
import { SideMenu } from '../../../components/Dashboard/SideMenu/SideMenu';
import TopBar from '../../../components/Dashboard/TopBar/TopBar';
import Button from '../../../components/molecules/Button/Button';
import Card from '../../../components/Dashboard/Card/Card';
import { SearchTextbox } from '../../../components/forms/SearchTextbox/SearchTextbox';
import useTideTable from "../../../components/utility/TideReactTable/useTideTable";
import TideReactTable from "../../../components/utility/TideReactTable/TideReactTable";
import useFormState from '../../../hooks/useFormState';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../services/routes/appRoutes';
import Modal from '../../../components/Modal/Modal';
import { ApiContext } from '../../../services/api/api-config';
import { getNotifier } from '../../../services/notifier';
import { getCampaignTableColumns, getCampaignTableColumnsVendor, campaignSGroups } from './CampaignUtils';
import "./Campaign.scss";
import {SecurityContext} from "../../../services/SecurityManager";

export default function Campaign() {
  const [showingDeleteModalConfirm, setShowingDeleteModalConfirm] = useState();
  const [idToDelete, setIdToDelete] = useState(0);
  const {form, setForm} = useFormState({});
  const navigate = useNavigate();

  const customProp = 'campaignList';

  const api = useContext(ApiContext);
  const security = useContext(SecurityContext);

  //Don't show buttons for add campaign to ROLE_VENDOR
  const onVendorRole = security.isVendor();
  const onClientRole = security.isClient();

  /**
   * Handle new user click
   */
  const handleNewCampaign = useCallback( () => navigate(paths.campaignForm), [navigate]);

  /**
   * Show modal on remove click
   */
  const onRemoveClick = useCallback((id) => {
    setIdToDelete(id);
    setShowingDeleteModalConfirm(true);
  }, []);

  /**
   * Request filters
   */
  const requestFilters = useMemo(() => ({
    sGroups: campaignSGroups,
    name: form.name,
    'order[id]': 'desc'
  }), [form.name]);

  /**
   * Get campaign table columns
   */
  const campaignTableColumns = useMemo(() => getCampaignTableColumns({onRemoveClick, onClientRole}), [onClientRole, onRemoveClick]);

  /**
   * Get campaign table columns for vendor
   */
  const campaignTableColumnsVendor = useMemo(() => getCampaignTableColumnsVendor({onRemoveClick}), [onRemoveClick]);

  const requestOptions = useMemo(() => ({ customProp }), []);

  /**
   * Create campaigns tide table
   */
  const table = useTideTable({
    entity: 'campaigns',
    columns: onVendorRole ? campaignTableColumnsVendor : campaignTableColumns,
    requestFilters,
    requestOptions
  });
  

  /**
   * Handle remove confirm
   */
  const handleRemove = useCallback(() => {
    if (idToDelete > 0) {
      api.campaigns.delete(
        {id: idToDelete}
      ).then(response => {
        setIdToDelete(0);
        setShowingDeleteModalConfirm(false);
        getNotifier().success('Registro eliminado correctamente');
      })
      .catch(() => {
        getNotifier().error('Ocurrió un error al eliminar el registro');
        setIdToDelete(0);
      });
    }
  }, [api.campaigns, idToDelete]);

  /**
   * Close modal on cancel
   */
  const closeModal = useCallback(() => {
    setIdToDelete(false);
    setShowingDeleteModalConfirm(false);
  }, []);

  return (
    <div className='Campaign'>
      <SideMenu />
      <div className='right-content'>
        <TopBar />
        <div className='main-content'>
          <div className='col d-flex justify-content-between align-items-center gap-3 mt-4'>
            <SectionTitle className="m-0 p-0">
              CAMPAÑAS
            </SectionTitle>
            {!onVendorRole && !onClientRole && (
              <Button
                className={'submit btnNewProducer'}
                type='button'
                onClick={handleNewCampaign}
                id="add-new-campaign"
              >
                + Agregar Campaña
              </Button>
            )}
          </div>

          <div className="row mt-3">
            <Card>
              <div className='d-flex justify-content-between align-items-center gap-3 mt-3 mb-3'>
                <SearchTextbox
                    placeholder="Búsqueda por nombre de campaña"
                    value={form.name}
                    onChange={e => setForm({name: e.target.value})}
                />
              </div>
              {
                table.tableProps &&
                <TideReactTable 
                  {...table.tableProps}
                  className="users-table"
                />
              }
              
              {
                showingDeleteModalConfirm &&
                <Modal
                  title="Confirmar Eliminación"
                  mainButtonText="Confirmar"
                  mainButtonColor='danger'
                  mainButtonAction={handleRemove}
                  secondaryButtonText={'Cancelar'}
                  secondaryButtonAction={() => {
                      setShowingDeleteModalConfirm(false);
                      setIdToDelete(0);
                  }}
                  onClose={closeModal}
                >
                  <div className='GrowerChangeStatusButtons__modal-content'>
                    <div className='GrowerChangeStatusButtons__modal-content-title'>
                      ¿Está seguro de eliminar el registro?
                    </div>
                  </div>
                </Modal>
              }
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
